import React from 'react'
import { StyleSheet, View, ViewStyle } from 'react-native'
// import styles from './index.scss'


interface Props {
    style?: ViewStyle|Array<ViewStyle>;
}

const Layout: React.FC<Props> = (props) => {

    const { style } = props;

    return (
        <View {...props} style={[styles.layout, style]}>
            {props.children}
        </View>
    );

};

const styles = StyleSheet.create({
    layout: {
        width: '100%'
    }
});

export {
    Layout
}